import { useUser } from "../contexts/UserProvider"
import { LinearProgress } from '@mui/material';

const AuthGate = ({ children }) => {
    const { profile, isLoggedIn } = useUser();

    if (isLoggedIn === null || (isLoggedIn && !profile)) {
        return <LinearProgress color="success" />
    }

    return children;
}

export default AuthGate;
